import React, { useState, useRef } from "react";
import Logo from "./Logo";
import Burger from "./Burger";
import Navbar from "layout/navbar/Navbar";
import Loader from "components/loader/Loader";
import { NavbarToggleContextProvider } from "context/navbar/NavbarContext";
import { useMediaPlayerContext } from "hooks/useContextAll";

const Header = () => {
    const media = useMediaPlayerContext();
    const loaderRef = useRef();
    const [showLoader, setShowLoader] = useState(true);

    const handleLoader = (withMusic) => {
        let loader = loaderRef.current;
        loader.classList.add("inactive");

        if (withMusic) {
            media.handlePlaying();
        }
        setTimeout(() => {
            return setShowLoader(false);
        }, 500);
    };

    return (
        <NavbarToggleContextProvider>
            {showLoader && (
                <Loader loaderRef={loaderRef} handleLoader={handleLoader} />
            )}
            <header role="banner" className="header" id="header">
                <div className="container">
                    <Logo />
                    <Navbar />
                    <Burger />
                </div>
            </header>
        </NavbarToggleContextProvider>
    );
};

export default Header;
